<template>
	<Transition name="fade">
		<div v-if="isVisible" class="error-message">
			<div class="error-content">
				<span v-html="text"></span>
				<button class="close-button" @click="close">×</button>
			</div>
		</div>
	</Transition>
</template>

<script setup lang="ts">
import { ref, computed, watch, onUnmounted } from 'vue';

const props = defineProps({
	text: {
		type: String,
		required: true
	}
});

const emit = defineEmits(['close']);

const isVisible = ref(false);
let timeoutId: number | null = null;

const duration = computed(() => {
	// based on number of words : 32 words = 8 sec
	const calculatedDuration = props.text.trim().split(' ').length / 4 * 1000;
	return calculatedDuration > 5000 ? calculatedDuration : 5000;
});

const show = () => {
	isVisible.value = true;
	if (timeoutId) {
		clearTimeout(timeoutId);
	}
	timeoutId = window.setTimeout(() => {
		close();
	}, duration.value); // 
};

const close = () => {
	isVisible.value = false;
	if (timeoutId) {
		clearTimeout(timeoutId);
		timeoutId = null;
	}
	emit('close');
};

watch(() => props.text, (newText) => {
	if (newText) {
		show();
	} else {
		close();
	}
}, { immediate: true });

onUnmounted(() => {
	if (timeoutId) {
		clearTimeout(timeoutId);
	}
});
</script>

<style scoped>
.error-message {
	font-family: var(--font-body);
	position: fixed;
	bottom: 20px;
	right: 20px;
	background-color: rgba(255, 155, 155, 0.92);
	color: black;
	padding: 15px;
	border-radius: var(--border-radius-default);
	max-width: 600px;
	z-index: 3000;
	box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
}

.error-content {
	position: relative;
	padding-right: 30px;
	padding-top: 5px;
}

.close-button {
	position: absolute;
	top: 0;
	right: 0;
	background: none;
	border: none;
	font-size: 20px;
	cursor: pointer;
	padding: 5px;
	color: inherit;
	opacity: 0.7;
	transition: opacity 0.2s;
	line-height: 1;
	height: 24px;
	width: 24px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.close-button:hover {
	opacity: 1;
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}
</style>
